import { render, staticRenderFns } from "./buy-with-prime.vue?vue&type=template&id=27a2dcf1&"
import script from "./buy-with-prime.vue?vue&type=script&lang=js&"
export * from "./buy-with-prime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports